import { synthesizeDataWithJSONSchema } from '@criteria/synthetic-data';
// See https://spec.openapis.org/oas/v3.1.0#style-values
function serialize(value) {
    if (value === null) {
        return '';
    }
    if (Array.isArray(value)) {
        return value.map((child) => serialize(child)).join(',');
    }
    if (typeof value === 'object') {
        return Object.entries(value)
            .map(([key, childValue]) => `${key},${serialize(childValue)}`)
            .join(',');
    }
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
        return encodeURIComponent(value);
    }
    else {
        return encodeURIComponent(`${value}`);
    }
}
export function exampleQueryForParameter(parameter) {
    var _a;
    return serialize(synthesizeDataWithJSONSchema((_a = parameter.schema) !== null && _a !== void 0 ? _a : {}));
}
